import React from 'react'

import {
  shape,
  string,
  bool,
  func,
} from 'prop-types'

import AccountSection from './Components/AccountSection/AccountSection'
import BuyerSection from './Components/BuyerSection/BuyerSection'
import GdprNotice from './Components/GdprNotice/GdprNotice'
import ProjectsSection from './Components/ProjectsSection/ProjectsSection'
import SellerSection from './Components/SellerSection/SellerSection'
import SubscriptionSection from './Components/SubscriptionSection/SubscriptionSection'

function UserInfoMenu({
  userData,
  locale = 'en',
  handleLogout,
  newRoyaltyUi = false,
}) {
  const attributes = userData?.attributes || {}
  const { subscriptionMenuEnabled, username, gdprConsent } = attributes
  const isAdmin = attributes.adminDashboard?.url?.length > 0

  return (
    <div className="unified-nav__dropdown unified-nav__dropdown--user">
      {gdprConsent === 'undecided' && <GdprNotice locale={locale} />}

      <SellerSection locale={locale} newRoyaltyUi={newRoyaltyUi} />

      {subscriptionMenuEnabled && <SubscriptionSection locale={locale} />}

      <BuyerSection locale={locale} />

      <ProjectsSection locale={locale} />

      <AccountSection
        locale={locale}
        isAdmin={isAdmin}
        adminUrl={attributes.adminDashboard?.url}
        username={username}
        onLogout={handleLogout}
      />
    </div>
  )
}

UserInfoMenu.propTypes = {
  userData: shape({
    attributes: shape({
      gdprConsent: string,
      adminDashboard: shape({
        url: string,
      }),
      username: string,
      subscriptionMenuEnabled: bool,
    }),
  }).isRequired,
  locale: string,
  handleLogout: func.isRequired,
  newRoyaltyUi: bool,
}

export default UserInfoMenu
